import UserLayout from './UserLayout';
import PeopleForm from '../PeopleForm';
import { useNavigate } from 'react-router-dom';

const DASHBOARD_PAGE_KEY = 'cabaza_dashboard_page';

/**
 * Dashboard wrapper for PeopleForm component
 * Displays PeopleForm within the dashboard layout (with menu and header)
 * PeopleForm is reusable - used here in dashboard mode (without header/footer)
 * and elsewhere in public mode (with full page layout)
 */
const DashboardPeopleForm = ({ onLogout }) => {
    const navigate = useNavigate();

    // Get the current dashboard page from localStorage to highlight correct menu item
    const currentDashboardPage = localStorage.getItem(DASHBOARD_PAGE_KEY) || 'contacts';

    const handleBack = () => {
        // Set flag to show "Mes contacts" page after redirect
        localStorage.setItem(DASHBOARD_PAGE_KEY, 'contacts');
        navigate('/');
    };

    // Handle navigation from menu - save page and go to dashboard
    const handleNavigate = (page) => {
        localStorage.setItem(DASHBOARD_PAGE_KEY, page);
        navigate('/');
    };

    return (
        <UserLayout currentPage={currentDashboardPage} onNavigate={handleNavigate} onLogout={onLogout}>
            <div className="bg-white rounded-lg p-8">
                <h1 className="text-2xl font-bold text-cabaza-purple mb-3 text-center">
                    Ajouter un contact
                </h1>
                <PeopleForm
                    onBack={handleBack}
                    isAdmin={false}
                    isAuthenticated={true}
                    showHeader={false}
                />
            </div>
        </UserLayout>
    );
};

export default DashboardPeopleForm;
